import { render, staticRenderFns } from "./production.vue?vue&type=template&id=04f297f2&scoped=true"
import script from "./production.vue?vue&type=script&lang=js"
export * from "./production.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f297f2",
  null
  
)

export default component.exports